const uiColor = [
    {
        color: 'primary',
        value: 2
    },
    {
        color: 'success',
        value: 3
    },
    {
        color: 'info',
        value: 4
    },
    {
        color: 'warning',
        value: 25
    },
    {
        color: 'danger',
        value: 6
    },
    {
        color: 'pink',
        value: 10
    },
    {
        color: 'dark',
        value: 5
    },
    {
        color: 'purple',
        value: 8
    }
];

export { uiColor };
